import { Link } from "react-router-dom";

import Card from "../../components/UI/card/card.component";
import { BackButtonContainer, GreenHeader, GreenP } from "../../global.styles";

const DriversPolicies = () => {
  return (
    <Card>
      <GreenHeader> Drivers and Employees Policies</GreenHeader>
      <BackButtonContainer>
        <GreenP>
          Effective Date: <strong>8th of May 2025</strong>
        </GreenP>
      </BackButtonContainer>
      <h2>Job Return and Driver Responsibility Policy</h2>
      <p>Applies To: All active Drivers on the RUFUS platform </p>
      <h3>1. Purpose</h3>
      <p>
        This policy establishes clear guidelines regarding the return of
        accepted jobs and outlines the expectations for punctuality,
        professionalism, and reliability from Drivers operating under RUFUS Taxi
        Services.
      </p>
      <h3>2. Job Acceptance and Commitment</h3>
      <ul>
        <li>
          Once a job is accepted, the Driver enters into a commitment to
          complete the job unless exceptional circumstances arise.
        </li>
        <li>
          Drivers must plan appropriately to ensure timely arrival at the pickup
          location and successful completion of the trip.
        </li>
      </ul>
      <h3>3. Job Return Policy </h3>
      <ul>
        <li>
          Once a Driver accepts a job, the Driver is expected to complete it.
          However, it is acceptable to return the job if necessary - as long as
          it is not returned too close to the scheduled pickup time.
        </li>
        <li>
          A Driver can return a job either to the Public Jobs list or, if it is
          a private booking, offer it to another Driver. If a late return occurs
          due to a genuine emergency (such as a vehicle breakdown or personal
          issue), it will be treated as acceptable.
        </li>
        <li>
          Repeated late returns without a valid reason, especially those
          affecting customer experience, can disrupt the service and will be
          recorded as a late return violation and may result in account review,
          suspension, or deactivation..
        </li>
      </ul>
      <h3>4. Accountability and Monitoring</h3>
      <ul>
        <li>
          All job activities are tracked. If a pattern of job returns, delays,
          or customer complaints is identified, RUFUS reserves the right to take
          disciplinary action.
        </li>
        <li>
          Drivers are responsible for monitoring traffic conditions and
          adjusting departure times accordingly.
        </li>
      </ul>
      <h3>5. Disciplinary Action</h3>
      <p>Violations of this policy may result in the following actions: </p>
      <ul>
        <li>First Offense: Formal written warning </li>
        <li>Second Offense: Temporary suspension from job access</li>
        <li>Third Offense: Permanent account deactivation</li>
      </ul>
      <p>
        RUFUS reserves the right to bypass disciplinary steps in cases of severe
        or repeated misconduct.{" "}
      </p>
      <h3>6. Appeal Process</h3>
      <p>
        Drivers may appeal any disciplinary action by submitting a written
        explanation to our{" "}
        <strong>
          <Link to="/contact">Contact Form</Link>
        </strong>{" "}
        within 5 business days of notification.{" "}
      </p>
      <br />
      <h2>Safeguarding Policy</h2>
      <h3>1. Purpose of the Policy</h3>
      <p>
        This Safeguarding Policy outlines the approach RUFUS TAXI SERVICES LTD
        takes to protect and promote the welfare of vulnerable children and
        adults who come into contact with our staff and Drivers.
      </p>
      <p>
        The policy is in place to ensure all employees, including Drivers, are
        aware of how to recognise, respond to, and report any safeguarding
        concerns appropriately. It covers procedures for reporting, escalation,
        training, and review. The safety and well-being of our passengers is our
        top priority, and this policy helps ensure we meet our duty of care
        obligations.
      </p>
      <h3>3. Reporting and Management of Issues</h3>
      <p>
        All employees and Drivers are trained during induction and through
        annual refresher sessions on how to identify and report safeguarding
        concerns.
      </p>
      <p>If a safeguarding issue arises:</p>
      <ul>
        <li>
          The concern must be reported immediately to the Safeguarding Lead.
        </li>
        <li>A written record must be completed within 24 hours.</li>
        <li>
          The DSL will determine whether the concern needs referral to external
          agencies.
        </li>
      </ul>
      <p>
        <strong>Emergency Contacts and External Reporting Lines:</strong>
      </p>
      <ul>
        <li>
          <strong>Police:</strong> 999 (emergency) / 101 (non-emergency)
        </li>
        <li>
          <strong>
            Bristol City Council Adult Care Services (Care Direct):
          </strong>{" "}
          0117 922 2700
        </li>
        <li>
          <strong>Children & Families Services (First Response):</strong> 0117
          903 6444
        </li>
        <li>
          <strong>Website:</strong>{" "}
          https://www.bristol.gov.uk/residents/people-and-communities/report-abuse-or-neglect
        </li>
        <li>
          <strong>NSPCC Helpline:</strong> 0808 800 5000 / www.nspcc.org.uk
        </li>
      </ul>
      <h3>4. Escalation and Determination of Safeguarding Reports</h3>
      <ul>
        <li>
          The DSL will assess the reported issue and decide the appropriate
          course of action.
        </li>
        <li>
          In urgent cases, the DSL will contact external safeguarding services
          immediately.
        </li>
        <li>
          The DSL is responsible for chasing responses from external agencies,
          keeping internal records, and ensuring the matter is handled in line
          with statutory obligations.
        </li>
        <li>
          Serious concerns must be escalated within 2 hours of initial
          notification.
        </li>
      </ul>
      <h3>5. Policy Awareness and Staff Training</h3>
      <p>All staff and Drivers will:</p>
      <ul>
        <li>Receive safeguarding training during induction.</li>
        <li>Be issued with the policy and sign to confirm understanding.</li>
        <li>
          Attend refresher training annually or when the policy is updated.
        </li>
        <li>
          Be notified of policy updates by email and during team meetings.
        </li>
      </ul>
      <h3>6. Policy Review and Responsibility</h3>
      <p>This policy will be reviewed annually or sooner if:</p>
      <ul>
        <li>
          There are significant changes to safeguarding legislation or local
          procedures.
        </li>
        <li>The current Safeguarding Lead is no longer employed.</li>
        <li>New risks or safeguarding concerns arise.</li>
      </ul>
      <br />
      <h2>
        Fit and Proper Person Policy
        <br />
        For Booking and Dispatch Staff, Data Handlers, and Designated
        Safeguarding Leads
      </h2>
      <h3>1. Purpose</h3>
      <p>
        This policy outlines the standards and procedures RUFUS TAXI SERVICES
        LTD applies to ensure that individuals in key positions—such as booking
        and dispatch staff, those handling personal data, and Designated
        Safeguarding Leads—are deemed fit and proper to carry out their duties
        responsibly, safely, and in compliance with legal and ethical
        obligations.
      </p>
      <h3>2. Scope</h3>
      <p>This policy applies to all:</p>
      <ul>
        <li>Booking and dispatch staff</li>
        <li>
          Staff who handle personal and sensitive data related to bookings
        </li>
        <li>Individuals acting as Designated Safeguarding Leads (DSLs)</li>
      </ul>
      <h3>3. Definition of a Fit and Proper Person</h3>
      <p>A fit and proper person is someone who:</p>
      <ul>
        <li>
          Has the character, competence, and integrity necessary for their role
        </li>
        <li>Has not committed offenses relevant to their duties</li>
        <li>Can be trusted with confidential or sensitive information</li>
        <li>Understands and upholds safeguarding responsibilities</li>
        <li>Acts in the best interests of customers and the company</li>
      </ul>
      <h3>4. Eligibility Criteria</h3>
      <p>All relevant personnel must meet the following:</p>
      <ul>
        <li>
          <strong>Disclosure and Barring Service (DBS) Check:</strong> A basic
          DBS check is required for all applicable staff. An enhanced DBS is
          required for any staff designated as a DSL.
        </li>
        <li>
          <strong>Right to Work:</strong> Must provide valid proof of right to
          work in the UK.
        </li>
        <li>
          <strong>Reference Checks:</strong> At least two references must be
          obtained, one from a recent employer where possible.
        </li>
        <li>
          <strong>Employment History Review:</strong> Any unexplained gaps or
          inconsistencies must be clarified.
        </li>
        <li>
          <strong>Interview Assessment:</strong> Suitability assessed through
          interview questions focusing on data protection, safeguarding
          awareness, and customer interaction scenarios.
        </li>
      </ul>
      <h3>5. Ongoing Responsibilities</h3>
      <p>All covered personnel are expected to:</p>
      <ul>
        <li>Adhere to data protection laws, including the UK GDPR</li>
        <li>Report safeguarding concerns to the DSL or relevant authorities</li>
        <li>Treat all information confidentially and responsibly</li>
        <li>
          Participate in regular safeguarding and data protection training
        </li>
        <li>
          Notify management of any changes in circumstances (e.g., criminal
          charges)
        </li>
      </ul>
      <h3>6. Designated Safeguarding Lead (DSL) Requirements</h3>
      <p>In addition to the above:</p>
      <ul>
        <li>Must hold an enhanced DBS check</li>
        <li>Must complete Level 2 or higher Safeguarding Training</li>
        <li>
          Must keep up-to-date knowledge of safeguarding practices and
          legislation
        </li>
        <li>Must maintain a log of safeguarding concerns and actions taken</li>
      </ul>
      <h3>7. Monitoring and Compliance</h3>
      <ul>
        <li>Annual DBS renewal (or as required)</li>
        <li>Performance appraisals and spot checks</li>
        <li>Ongoing training in safeguarding and data protection</li>
        <li>Immediate investigation of any conduct or data breach concerns</li>
      </ul>
      <h3>8. Disqualification Criteria</h3>
      <p>An individual may be deemed not fit and proper if they:</p>
      <ul>
        <li>
          Have been convicted of relevant criminal offenses (e.g., fraud, sexual
          offenses, data breaches)
        </li>
        <li>Breach confidentiality or data protection laws</li>
        <li>Fail to act on safeguarding concerns</li>
        <li>Demonstrate ongoing poor conduct or performance</li>
      </ul>
      <h3>9. Policy Breaches</h3>
      <p>
        Any breach of this policy will be investigated and may lead to
        disciplinary action, including termination of employment or notification
        to licensing or regulatory authorities.
      </p>
      <br />
      <h2>Training Policy</h2>
      <h3>1. Purpose of the Policy</h3>
      <p>
        This policy establishes the minimum training standards for all staff and
        contractors at Rufus Taxi Services Ltd to ensure compliance with legal
        obligations, promote passenger safety, and uphold service excellence. It
        addresses:
      </p>
      <ul>
        <li>
          Mandatory training areas, including safeguarding, data protection, and
          equality.
        </li>
        <li>
          Processes for reviewing and updating training materials to reflect
          legislative changes and operational needs.
        </li>
        <li>
          Record-keeping requirements to track training completion and
          effectiveness.
        </li>
      </ul>
      <p>
        The policy ensures staff are equipped to handle complaints, protect
        vulnerable passengers, adhere to data privacy laws, and deliver
        inclusive services. Training will be reviewed annually or as required by
        changes in legislation, incident trends, or licensing requirements.
      </p>
      <h3>2. Training Provided</h3>
      <p>
        All staff and contractors must complete the following training, tailored
        to their roles:
      </p>
      <p>
        <strong>A. Complaints Policy Training</strong>
      </p>
      <ul>
        <li>
          <strong>Who:</strong> Drivers, vehicle proprietors, booking handlers,
          dispatchers, and the Safeguarding Lead.
        </li>
        <li>
          <strong>Content:</strong> Procedures for handling complaints,
          escalation processes, and resolution timelines as per the{" "}
          <em>Operators Complaints Policy</em>.
        </li>
      </ul>
      <p>
        <strong>B. Safeguarding & Vulnerable Adults Training</strong>
      </p>
      <ul>
        <li>
          <strong>Who:</strong> Booking handlers, information handlers, and the
          Safeguarding Lead.
        </li>
        <li>
          <strong>Content:</strong> Recognizing signs of abuse, reporting
          protocols, and duty of care under the
          <em>Operators Safeguarding Policy</em>.
        </li>
      </ul>
      <p>
        <strong>C. Equalities Training</strong>
      </p>
      <ul>
        <li>
          <strong>Who:</strong> Booking handlers, information handlers, and the
          Safeguarding Lead.
        </li>
        <li>
          <strong>Content:</strong>
        </li>
        <ul>
          <li>
            Accessibility requirements (e.g., wheelchair-friendly vehicles).
          </li>
          <li>Assistance dog compliance (Equality Act 2010).</li>
          <li>Dementia-friendly communication and mobility assistance.</li>
        </ul>
      </ul>
      <p>
        <strong>D. Data Protection/GDPR Training</strong>
      </p>
      <ul>
        <li>
          <strong>Who:</strong> All Drivers, proprietors, booking/information
          handlers, and the Safeguarding Lead.
        </li>
        <li>
          <strong>Content:</strong> Secure data handling, breach reporting, and
          GDPR compliance.
        </li>
      </ul>
      <p>
        <strong>E. Additional Training</strong>
      </p>
      <ul>
        <li>
          <strong>Bristol City Council Licensing Policies:</strong> Drivers and
          proprietors must complete training on conditions for hackney/private
          hire licensing (e.g., vehicle standards, Driver conduct).
        </li>
        <li>
          <strong>Health & Safety:</strong> Emergency response, accident
          reporting, and COVID-19 protocols.
        </li>
        <li>
          <strong>Customer Service:</strong> Conflict resolution and cultural
          sensitivity.
        </li>
      </ul>
      <h3>3. Training Review Process</h3>
      <ul>
        <li>
          <strong>Frequency:</strong> Annual review by the Safeguarding Lead and
          Operations Manager.
        </li>
        <li>
          <strong>Triggers for Updates:</strong>
          <ul>
            <li>Legislative changes (e.g., GDPR updates, equality laws).</li>
            <li>Safeguarding incident trends or recommendations.</li>
            <li>Revisions to Bristol City Council licensing policies.</li>
          </ul>
        </li>
        <li>
          <strong>Delivery Methods:</strong> Blended learning (e.g., online
          modules, in-person workshops) to ensure relevance and accessibility.
        </li>
      </ul>
      <h3>4. Training Records</h3>
      <ul>
        <li>
          <strong>Records Kept:</strong>
          <ul>
            <li>
              Name, job role, training type, completion date, and certificates.
            </li>
            <li>Training materials and versions used.</li>
          </ul>
        </li>
        <li>
          <strong>Storage:</strong> Digitally stored on a secure,
          password-protected system with backups.
        </li>
        <li>
          <strong>Retention:</strong> 5 years post-employment or contract
          termination.
        </li>
        <li>
          <strong>Access:</strong> Restricted to the Safeguarding Lead, HR
          Manager, and auditors.
        </li>
      </ul>
      <h3>5. Compliance</h3>
      <p>
        Failure to complete mandatory training may result in suspension or
        termination. Refresher courses are required every 2 years or as
        legislation dictates.
      </p>
      <br />
      <h2>Policy on Employing Ex-Offenders</h2>
      <h3>1. Policy Statement</h3>
      <p>
        Rufus Taxi Services Ltd is committed to the fair treatment of all job
        applicants and employees, including those with criminal records. We
        actively promote equality of opportunity and believe that a criminal
        record should not automatically prevent someone from being considered
        for employment.
      </p>
      <h3>2. Purpose</h3>
      <p>
        The purpose of this policy is to ensure that individuals with criminal
        convictions are treated fairly and not discriminated against because of
        their past, while also safeguarding our passengers, employees, and the
        reputation of the business.
      </p>
      <h3>3. Scope</h3>
      <p>
        This policy applies to all applicants and employees at all levels of
        Rufus Taxi Services Ltd. It is particularly relevant to roles involving
        driving duties, customer service, and the handling of sensitive
        information.
      </p>
      <h3>4. Principles</h3>
      <ul>
        <li>
          We will consider applications from ex-offenders on a case-by-case
          basis, taking into account the nature of the offence, its relevance to
          the role, the time that has passed since the offence, and evidence of
          rehabilitation.
        </li>
        <li>
          Where applicable, we will carry out a Disclosure and Barring Service
          (DBS) check in line with current legislation and only request
          information relevant to the role.
        </li>
        <li>
          All information regarding criminal convictions will be handled
          confidentially and in accordance with the Data Protection Act 2018.
        </li>
        <li>
          Having a criminal record will not necessarily bar someone from
          employment with us. Only offences relevant to the safety,
          trustworthiness, or responsibilities of the position will be
          considered.
        </li>
      </ul>
      <h3>5. Implementation</h3>
      <ul>
        <li>
          Job applicants will be informed at the earliest stage if a role
          requires a DBS check.
        </li>
        <li>
          Those involved in recruitment will be appropriately informed of this
          policy to ensure consistent and fair treatment.
        </li>
        <li>
          Applicants will be given the opportunity to provide details of their
          conviction(s) and any mitigating circumstances.
        </li>
        <li>
          Decisions will be documented and handled with care and
          confidentiality.
        </li>
      </ul>
      <h3>6. Review and Monitoring</h3>
      <p>
        This policy will be reviewed annually or when there is a change in
        legislation or regulatory guidance. Rufus Taxi Services Ltd will monitor
        the implementation of this policy and take steps to address any issues
        that arise.
      </p>
      <br />
      <h2>Contact Us</h2>
      <p>
        If You have any questions about these Policies, please contact us by
        filling our{" "}
        <strong>
          <Link to="/contact">Contact Form</Link>
        </strong>
      </p>
      <p>Or reach out by post.</p>
      <p>
        <strong>Address:</strong> <br />
        Waway LTD
        <br />
        2530 Aztec West (Ground Floor)
        <br />
        Almondsbury
        <br />
        BS32 4AW
        <br />
        Bristol
        <br />
        UK
      </p>
    </Card>
  );
};

export default DriversPolicies;
